export interface RHUserNameComponents {
    firstName: string
    lastName: string
}


export class RHUserName {

    static fullNameWithComponents(nameComponents: RHUserNameComponents): string {
        return [nameComponents.firstName.trim(), nameComponents.lastName.trim()].join(" ")
    }


    static failedRequirementMessageForComponents(nameComponents: RHUserNameComponents): string | undefined {
        if (!nameComponents.firstName.trim()) {
            return "Palun sisesta eesnimi."
        }
        if (!nameComponents.lastName.trim()) {
            return "Palun sisesta perekonnanimi."
        }
        if (RHUserName.fullNameWithComponents(nameComponents).length > 200) {
            return "Nimi on liiga pikk."
        }
        return undefined
    }

}
